import { formatTime } from 'infrastructure/functions/format-time';
import { useTranslation } from 'react-i18next';

import styles from './styles.module.scss';

import type { FC } from 'react';

interface Props {
  callId: string;
  currentTimeSeconds: number;
  durationSeconds: number;
}

const Time: FC<Props> = ({ callId, currentTimeSeconds, durationSeconds }) => {
  const { t } = useTranslation();
  return (
    <div className={styles['time-container']}>
      <span>
        {t('labels.callId')}:
        <span className={styles['call-id']}> {callId}</span>
      </span>
      {formatTime(currentTimeSeconds)} / {formatTime(durationSeconds)}
    </div>
  );
};

export default Time;
